import React from "react";
import { Phone, Envelope, InstagramLogo, FacebookLogo, YoutubeLogo, WhatsappLogo, MapPin } from "@phosphor-icons/react";
import { useLanguage } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  const navLinks = [
    { label: t.nav.home, href: "#inicio" },
    { label: t.nav.services, href: "#servicios" },
    { label: t.nav.materials, href: "#materiales" },
    { label: t.nav.gallery, href: "#galeria" },
    { label: t.nav.testimonials, href: "#testimonios" },
    { label: t.header.quote, href: "#cotizacion" },
  ];

  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="mb-4">
              <span className="font-['Cormorant_Garamond'] text-2xl font-semibold text-white tracking-tight">DOMINICAN </span>
              <span className="font-['Cormorant_Garamond'] text-2xl font-light text-[#FFD700] tracking-tight">UPHOLSTERED</span>
            </div>
            <p className="text-sm text-[#FFD700] italic font-light mb-2">{t.footer.tagline}</p>
            <p className="text-sm text-zinc-400 font-light leading-relaxed mb-6">{t.footer.slogan}</p>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/dominican_upholstered_nj?igsh=bnN4cXFxYnNleXQ0" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/10 text-zinc-400 hover:text-[#FFD700] hover:border-[#FFD700] transition-colors" data-testid="footer-instagram"><InstagramLogo size={18} /></a>
              <a href="https://www.facebook.com/share/1CZrwp2ESR/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/10 text-zinc-400 hover:text-[#FFD700] hover:border-[#FFD700] transition-colors" data-testid="footer-facebook"><FacebookLogo size={18} /></a>
              <a href="https://www.youtube.com/@Dominicanupholstered9906" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/10 text-zinc-400 hover:text-[#FFD700] hover:border-[#FFD700] transition-colors" data-testid="footer-youtube"><YoutubeLogo size={18} /></a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#FFD700] mb-6">{t.footer.links}</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => <li key={link.href}><a href={link.href} className="text-sm text-zinc-400 hover:text-[#FFD700] transition-colors font-light">{link.label}</a></li>)}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#FFD700] mb-6">{t.footer.contact}</h4>
            <div className="space-y-4">
              <p className="text-sm text-white font-medium">Daniel Salas</p>
              <a href="https://wa.me/19732883496" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-zinc-400 hover:text-[#25D366] transition-colors"><WhatsappLogo size={16} className="text-[#25D366]" />973-288-3496</a>
              <a href="https://wa.me/18622714917" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-zinc-400 hover:text-[#25D366] transition-colors"><WhatsappLogo size={16} className="text-[#25D366]" />862-271-4917</a>
              <a href="mailto:dominicanupholstered.nj@gmail.com" className="flex items-center gap-3 text-sm text-zinc-400 hover:text-[#FFD700] transition-colors"><Envelope size={16} className="text-[#FFD700]" />dominicanupholstered.nj@gmail.com</a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#FFD700] mb-6">{t.footer.locationTitle}</h4>
            <div className="flex items-start gap-3">
              <MapPin size={16} className="text-[#FFD700] mt-0.5 flex-shrink-0" />
              <a href="https://maps.google.com/?q=1045+North+Broad+St+Elizabeth+NJ+07208" target="_blank" rel="noopener noreferrer" className="text-sm text-zinc-400 hover:text-[#FFD700] transition-colors font-light leading-relaxed">1045 North Broad St.<br />Elizabeth, NJ 07208</a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-zinc-500">&copy; {new Date().getFullYear()} Dominican Upholstered. {t.footer.rights}</p>
          <p className="text-xs text-zinc-600 italic">{t.footer.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
